<template>
  <div class="insert-user-page top-zero-radius p-2"
           :class="{'w-full': inModal, 'vx-card  main-box md:w-2/3 lg:w-1/2': !inModal}">
    <vs-row class="mb-1 justify-center">
      <custom-profile-image-input v-model="newUser.avatar" />
    </vs-row>
    <custom-validate-input class="w-full"
                           :label="$t('users.general.labels.name')"
                           @keydown.enter="sendData"
                           :in-valid="$v.newUser.name.value.$invalid"
                           :invalid-text="newUser.name.isInvalid"
                           v-model="newUser.name"/>

    <custom-validate-input :label="$t('users.general.labels.family')"
                           class="w-full"
                           @keydown.enter="sendData"
                           :in-valid="$v.newUser.lastName.value.$invalid"
                           :invalid-text="newUser.lastName.isInvalid"
                           v-model="newUser.lastName"/>

    <custom-email-input :label="$t('users.general.labels.email')"
                        :classes="{'w-full': true}"
                        @keydown.enter="sendData"
                        :in-valid="$v.newUser.email.value.$invalid"
                        :invalid-text="newUser.email.isInvalid"
                        v-model="newUser.email"/>

<!--          <div v-if="setRole" class="select-role">
            <custom-validate-input :value="newUser.role"
                                   :classes="{'w-full': true}"
                                   :in-valid="$v.newUser.role.$invalid"
                                   :disabled="true"
                                   :label="`${$t('users.general.labels.role')}`"
                                   @clicked="suggestRolePromptStatus = true"/>

            <div v-if="$route.name !== 'insertUserReceive'" class="suggest-modal-button"
                 @click="suggestRolePromptStatus = true">
              <custom-icon height="22px" width="22px" icon="list-icon" color-code="#197ed5" />
            </div>
          </div>-->
    <custom-modal :active="suggestRolePromptStatus"
                  :fixed-height="false"
                  @close="suggestRolePromptStatus = false">
      <template #header>
        <div class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>
            <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">

            </vs-col>

            <vs-spacer/>

            <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
              {{ $t('setting.accessGroup.title')}}
            </vs-col>

            <vs-spacer/>

            <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
              <div @click="suggestRolePromptStatus = false">
                <custom-icon icon="circle-x-icon" color="danger"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </template>
      <template #content>
        <div class="prompt-content py-2 px-3">
          <template>
            <keep-alive>
              <access-groups-list :selectable="true" v-model="newUser.role.id" @selected="handleSelectRole" />
            </keep-alive>
          </template>
        </div>
      </template>
    </custom-modal>

    <vs-button id="insertUserBTN" class="useral-action-button" @click="sendData"/>
  </div>
</template>

<script>
import {maxLength, required, email} from 'vuelidate/lib/validators'
import {mapGetters} from 'vuex'
import CustomSelect from '@/components/select/customSelect'
import {insertUser} from '@/http/requests/users'
// import {getRoles} from '@/http/requests/roles'
import axios from 'axios'
import CustomProfileImageInput from '../../../components/input/customProfileImageInput'
import CustomPhoneInput from '../../../components/input/customPhoneNumberInput.vue'
import CustomValidateInput from '../../../components/input/customValidateInput.vue'
import CustomEmailInput from '../../../components/input/customEmailInput.vue'
import CustomValidateTextarea from '@/components/input/customValidateTextarea.vue'
import CustomIcon from '@/components/icon/customIcon.vue'
import CustomModal from '@/components/modal/customModal.vue'

export default {
  name: 'insertUser',
  metaInfo () {
    return {
      title: this.$t('users.insert.title')
    }
  },
  components: {
    CustomModal,
    CustomIcon,
    CustomValidateTextarea,
    CustomEmailInput,
    CustomValidateInput,
    CustomPhoneInput,
    CustomProfileImageInput,
    CustomSelect},
  data () {
    return {
      tabIndex: 0,
      firstChange: true,
      suggestRolePromptStatus: false,
      userTypes: [
        {label: '-', value: '-1'},
        {label: this.$t('users.insert.gender.man'), value: '1'},
        {label: this.$t('users.insert.gender.woman'), value: '2'}
        /*{label: this.$t('users.types.company'), value: '3'}*/
      ],
      accessList: [],
      selectedAccess: [],
      accessTreeOption: {
        type: 'accessList'
      },
      groupsList: [
        {
          label: this.$t('users.insert.base'),
          value: 0
        }
      ],
      newUser: {
        avatar: {
          value: '',
          isValid: true
        },
        name: {
          isInvalid: '',
          value: ''
        },
        lastName: {
          isInvalid: '',
          value: ''
        },
        email: {
          isInvalid: '',
          value: ''
        },
        description: {
          isInvalid: '',
          value: ''
        },
        access: [],
        role: {
          value: '',
          id: []
        }
      },
      actions: {
        toolbar: [
          {
            id: 'insertUserBTN',
            icon: 'save-icon',
            iconPack: 'useral',
            color: 'success'
          }
        ],
        leftToolbar: [
          {
            id: {name: 'users'},
            type: 'link',
            icon: 'chevron-left-icon',
            iconPack: 'useral'
          }
        ]
      }
    }
  },
  props: {
    inModal: {
      type: Boolean,
      default: false
    },
    setRole: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      clubInfo: 'setting/getClubInfo'
    })
  },
  validations: {
    newUser: {
      name: {
        value: {
          required,
          maxLength: maxLength(30),
          regex (value) { return this.$u.validator('regex.user.name').test(value) }
        }
      },
      lastName: {
        value: {
          required,
          maxLength: maxLength(50),
          regex (value) { return this.$u.validator('regex.user.lastName').test(value) }
        }
      },
      email: {
        value: {
          required,
          email,
          maxLength: maxLength(50)
        }
      },
      role: {
        value: {
          // required,
          regex (value) { return this.setRole ? value.length > 0 : true }
        }
      }
    }
  },
  created () {
    if (!this.inModal) {
      this.$nextTick(() => {
        this.$store.dispatch('updateNavbarActions', this.actions)
        this.$store.dispatch('updateContentNavbarStyle', 'sticky')
        this.$store.dispatch('updateContentNavbarClass', 'md:w-2/3 lg:w-1/2 mx-auto')
      })
    }
    this.getAccessGroups()
  },
  methods: {
    handleSelectRole (node) {
      this.newUser.role.value = node[0].label
      this.suggestRolePromptStatus = false
    },
    nameValidator () {
      this.newUser.name.isInvalid = this.$v.newUser.name.value.regex ? '' : this.$t('users.insert.validators.nameIsWrong')
      if (!this.$v.newUser.name.value.required) this.newUser.name.isInvalid = this.$t('users.insert.validators.nameCantEmpty')
      else if (!this.$v.newUser.name.value.maxLength) this.newUser.name.isInvalid = this.$t('users.insert.validators.name')
    },
    lastNameValidator () {
      this.newUser.lastName.isInvalid = this.$v.newUser.lastName.value.regex ? '' : this.$t('users.insert.validators.familyIsWrong')
      if (!this.$v.newUser.lastName.value.required) this.newUser.lastName.isInvalid = this.$t('users.insert.validators.familyCantEmpty')
      else if (!this.$v.newUser.lastName.value.maxLength) this.newUser.lastName.isInvalid = this.$t('users.insert.validators.family')
    },
    getAccessGroups () {
      /*getRoles().then(response => {
        this.accessList = this.getRoles(response.data.data, true)
      })*/
    },
    getRoles (role, first = false) {
      const data = {
        parent: {
          id: role.id,
          title: role.name,
          parent_id: role.parent_id,
          permissions: role.permissions
        },
        children: [],
        options: {
          insertEnable: true,
          updateEnable: !first,
          deleteEnable: role.children.length === 0,
          selectable: !first
        }
      }

      if (role.children && role.children.length > 0) {
        role.children.forEach((child) => {
          data.children.push(this.getRoles(child))
        })
      }

      return data
    },
    sendData () {
      if (!this.$v.newUser.$invalid) {

        const user = {
          avatar: this.newUser.avatar.value || null,
          name: this.newUser.name.value,
          family: this.newUser.lastName.value,
          email: this.newUser.email.value
          /*role_id: null,*/
          /*group_id: null,*/
        }

        if (this.newUser.description.value) user.description = this.newUser.description.value

        if (this.newUser.role) user.role_id = this.newUser.role.id[0] || null

        insertUser(user).then((response) => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('users.insert.notifications.insert.success'),
            icon: 'icon-check',
            iconPack: 'feather',
            time: this.$u.getReadingTime(this.$t('users.insert.notifications.insert.success')),
            color: 'success'
          })
          this.$emit('inserted', response.data.data)

          if (!this.inModal) this.$router.push({name: 'users'})
        }).catch(error => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.warning.title'),
              text: this.$t('alert.warning.repeatedRequestText'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('alert.warning.repeatedRequestText')),
              color: 'warning'
            })
          } else {
            const error_mapper = {
              'phone_number': this.$t('users.notifications.parseError.phoneNumber'),
              'email': this.$t('users.notifications.parseError.email')
            }
            switch (error.response.status) {
            case 422:
              Object.keys(error.response.data.errors).forEach((error_key) => {
                const err = error_key.toString().split('.')
                if (error_mapper[err[err.length - 1]]) {
                  this.$vs.notify({
                    title: this.$t('alert.message.title'),
                    text: error_mapper[err[err.length - 1]],
                    color: 'danger',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: this.$u.getReadingTime(error_mapper[err[err.length - 1]])
                  })
                  error_mapper[err[err.length - 1]] = null
                } else {
                  this.$vs.notify({
                    title: this.$t('alert.error.title'),
                    text: this.$t('users.insert.notifications.insert.error'),
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: this.$u.getReadingTime(this.$t('users.insert.notifications.insert.error')),
                    color: 'danger'
                  })
                }
              })
              break

            default:
              this.$vs.notify({
                title: this.$t('alert.error.title'),
                text: this.$t('users.insert.notifications.insert.error'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: this.$u.getReadingTime(this.$t('users.insert.notifications.insert.error')),
                color: 'danger'
              })
              break
            }
          }

        })

      }
    }
  },
  watch: {
    'newUser.name.value': {
      handler () {
        this.nameValidator()
      },
      deep: true
    },
    'newUser.lastName.value': {
      handler () {
        this.lastNameValidator()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.vs-divider .vs-divider-border {
  border-color: #cecece !important;
}

.insert-user-page {
  width: 100%;
  height: calc(100% - 10px);

  .max-debt .vs-inputx {
    text-align: right !important;
  }

  .divider {
    margin: 20px 0;
    position: absolute;
    right: 0;
    left: 0;
    height: 1px;
    background: #cecece;
  }

  .select-role {
    position: relative;

    .suggest-modal-button, .new-suggest-modal-button {
      position: absolute;
      bottom: 0;
      right: 5px;
      top: 8px;
      width: 25px !important;
      height: 25px !important;
      padding: 0;
      border: 1px solid #197ed5;
      border-radius: .5rem;
      color: #197ed5;
      background: white;
      cursor: pointer;
    }

    .new-suggest-modal-button {
      right: 5px;
      padding-right: 3px;
      border: 1px solid #28C76F;
      color: #28C76F;
    }
  }

  .fields-label {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 500;

    .text-danger {
      font-weight: bold;
    }
  }

  .insert-user-tabs {
    margin-top: 40px;
  }
}
</style>
